import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { MuckpileAnalyticsMapService } from './muckpile-analytics-map.service';
import { Device, muckpileQuery } from '@models';

@Component({
    selector: 'muckpile-list',
    templateUrl: './muckpile-list.component.html',
    styleUrls: ['./muckpile-list.component.scss']
})
export class MuckpileListComponent implements AfterViewInit, OnDestroy {
    @ViewChild('map', { static: false }) mapElement: ElementRef;
    
    public muckpileData$ = this.fragQuery.muckpileData$;
    public muckpile$ = this.fragQuery.muckpile$;
    public device$ = this.fragQuery.device$;
    public particleSizeUnit$ = this.fragQuery.particleSizeUnit$;
    public areaUnit$ = this.fragQuery.AreaAbbr$;
    public graph$ = this.fragQuery.graph$
    public isImportedOffSpec:boolean = false 
    public isActualOffSpec = false
    private mapInitialized = false;

    constructor(
        private fragQuery: FragQueryService,
        private muckpileAnalyticsMapService: MuckpileAnalyticsMapService,
    ) {}

    ngAfterViewInit() {
        if (!this.mapInitialized) {
            setTimeout(() => {
                this.muckpileAnalyticsMapService.initializeMap([0, 0], this.mapElement);
                this.mapInitialized = true;
            }, 100); // Optional delay for smoother rendering
        }
    }

    ngOnDestroy() {
        this.muckpileAnalyticsMapService.cleanup();
        this.mapInitialized = false;
    }

    public isCustomSizeEnabled(device: Device | null): boolean {
            if (!device) return false;
            return device.preferCustomSizes && device.targetSizes !== '[]' && device.targetSizes.length > 0;
    }

    public setImportedOffSpec(isOffSpec: boolean) {
        this.isImportedOffSpec = isOffSpec
    }

    public setActualOffSpec(isOffSpec: boolean) {
        this.isActualOffSpec = isOffSpec
    }

    public isEmptyObject = (obj:muckpileQuery.details.Fragment): boolean => {
        return obj === null || obj === undefined ||
            (Array.isArray(obj.psd) && obj.psd.length === 0) &&
            (Array.isArray(obj.dxx) && obj.dxx.length === 0);
    };
}